import { render, staticRenderFns } from "./EditTemplate.vue?vue&type=template&id=52262c65&scoped=true&"
import script from "./EditTemplate.vue?vue&type=script&lang=js&"
export * from "./EditTemplate.vue?vue&type=script&lang=js&"
import style0 from "./EditTemplate.vue?vue&type=style&index=0&id=52262c65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52262c65",
  null
  
)

component.options.__file = "EditTemplate.vue"
export default component.exports